import { useGetProjectsQuery } from "../../features/projects/ProjectsApi";
import ProjectItem from "./ProjectItem";

export default function ProjectList() {

	const {data: projects, isLoading, isError } = useGetProjectsQuery();

	let content = null;
	if (isLoading) {
		content = <div>Loading...</div>;
	}
	else if (!isLoading && isError) {
		content = <div>There was an error!</div>;
	}
	else if (!isLoading && !isError && projects?.length === 0) {
		content = <div>No projects found!</div>;
	}
	else if (!isLoading && !isError && projects?.length > 0) {
		content = projects.map(project => <ProjectItem key={project.id} project={project} />)
	}
	else {
		content = <div>Something went wrong!</div>;
	}

	return (
		<div>
			<h3 className="text-xl font-bold">Projects</h3>
			<div className="mt-3 space-y-4">
				{content}
			</div>
		</div>
	);
}
